/* NOTE: This mimics what we do in webapp and links to our custom version of
React -- this was not added with npm */
module.exports = require("react").__internalAddons.CSSTransitionGroup;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-css-transition-group/index.js
 ** module id = 527
 ** module chunks = 0 2
 **/